/* eslint-disable class-methods-use-this */
import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['incomeManualField', 'incomeManualInput', 'errorMessage'];

  static values = {
    highestIncome: Number,
  };

  connect() {
    $(this.incomeManualInputTarget).mask('#.##0', { reverse: true });

    $('form').on('submit', (e) => {
      const parsedVal = parseFloat(this.incomeManualInputTarget.value.replace(/\./g, ''));

      if (parsedVal < this.highestIncomeValue) {
        e.preventDefault();

        $(this.incomeManualInputTarget).addClass('creator-onboarding-form__input--invalid');
        $(this.errorMessageTarget).show();
      }
    });
  }

  showIncomeManualField() {
    $(this.incomeManualFieldTarget).removeClass('d-none');

    $.$EventBus.emit('form:reattachValidation');
  }

  hideIncomeManualField() {
    $(this.incomeManualFieldTarget).addClass('d-none');

    $.$EventBus.emit('form:reattachValidation');
  }

  clearError() {
    $(this.incomeManualInputTarget).removeClass('creator-onboarding-form__input--invalid');
    $(this.errorMessageTarget).hide();
  }
}
